export default __webpack_public_path__ + "static/media/home-slider4.e0225729.svg";